import {
  catalog,
  LEGACY_POSTHOG_NAMES,
  posthogCapturePublisher,
  registerCatalogPublishers,
  setMissingPublisherReporter,
} from '@onark/observability';

import { capture } from './posthog';

/**
 * Register the OnArk event catalog (ADR 0002) with the BROWSER runtime.
 *
 * Called once from `instrumentation-client.ts`, which Next runs before any
 * page code in both router trees — so no component has to import the right
 * module first for its events to go anywhere. The server runtimes register
 * from `instrumentation.ts`; a runtime that emits without registering now
 * fails loudly (see `@onark/observability`) instead of dropping silently.
 *
 * capture() from utils/posthog is the seam ON PURPOSE: it carries the
 * pre-init queue that keeps mount-time events from being dropped before
 * posthog.init. The rename map keeps pre-catalog PostHog dashboards working
 * (welcomeAboardCheckoutStarted / switchChurches etc.).
 */
export function registerBrowserObservability(): void {
  registerCatalogPublishers([
    posthogCapturePublisher<typeof catalog.schemas>(capture, {
      renameMap: LEGACY_POSTHOG_NAMES,
    }),
  ]);

  // The inline Rollbar snippet (components/global/HeadScripts) owns
  // window.Rollbar; before it loads this is a console.error, never a throw.
  setMissingPublisherReporter(error => {
    const rollbar = (
      globalThis as { Rollbar?: { error?: (e: unknown) => void } }
    ).Rollbar;

    if (rollbar?.error) rollbar.error(error);
    else console.error(error);
  });
}
